// "Grayscale display" preference (client Profile, phones). The filter goes on
// <html> because a filter on the root element does not become the containing
// block for position:fixed descendants, so the bottom tab bar stays pinned.
const KEY = 'orbit_grayscale';
const CLASS = 'orbit-grayscale';

export function isGrayscale() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function applyGrayscale(on) {
  document.documentElement.classList.toggle(CLASS, !!on);
}

export function setGrayscale(on) {
  applyGrayscale(on);
  try {
    if (on) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch { /* storage unavailable: still applied for this session */ }
}
